import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import ClientesPage, { BuscaClientes } from './pages/ClientesPage';
import Oportunidades from './pages/Oportunidades';
import CRM from './pages/CRM';
import Relatorios from './pages/Relatorios';
import GeradorArquivos from './pages/GeradorArquivos';
import PesquisaMarca from './pages/PesquisaMarca';
import Inpi from './pages/Inpi';
import Oposicao from './pages/Oposicao';
import ConsultarRpi from './pages/ConsultarRpi';
import Agenda from './pages/Agenda';
import Sdr from './pages/Sdr';
import Saudadora from './pages/Saudadora';
import Closer from './pages/Closer';
import Pap from './pages/Pap';
import Demandas from './pages/Demandas';
import Parceiros from './pages/Parceiros';
import DashboardRevista from './pages/DashboardRevista';
import FormCliente from './pages/FormCliente';
import Configuracoes from './pages/Configuracoes';
import Automacoes from './pages/Automacoes';
import Assistente from './pages/Assistente';
import Sugestoes from './pages/Sugestoes';
import Apis from './pages/Apis';
import GoogleMaps from './pages/GoogleMaps';
import Prospeccao from './pages/Prospeccao';
import Anotacoes from './pages/Anotacoes';
import Utilitarios from './pages/Utilitarios';
import AgenteVendas from './pages/AgenteVendas';
import Comunicacao from './pages/Comunicacao';
import SucessoCliente from './pages/SucessoCliente';
import Financeiro from './pages/Financeiro';
import Capital from './pages/Capital';
import Fornecedores from './pages/Fornecedores';
import FormFornecedor from './pages/FormFornecedor';
import Layout from './components/Layout';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [nomeUsuario, setNomeUsuario] = useState(localStorage.getItem('nomeUsuario') || '');
  const [cargoUsuario, setCargoUsuario] = useState(localStorage.getItem('cargoUsuario') || '');

  function handleLogin(t, nome, cargo) {
    localStorage.setItem('token', t);
    localStorage.setItem('nomeUsuario', nome);
    localStorage.setItem('cargoUsuario', cargo || '');
    setToken(t);
    setNomeUsuario(nome);
    setCargoUsuario(cargo || '');
  }

  function handleLogout() {
    localStorage.removeItem('token');
    localStorage.removeItem('nomeUsuario');
    localStorage.removeItem('cargoUsuario');
    setToken(null);
    setNomeUsuario('');
    setCargoUsuario('');
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={token ? <Navigate to="/painel" /> : <Login onLogin={handleLogin} />} />
        <Route element={token ? <Layout nomeUsuario={nomeUsuario} cargoUsuario={cargoUsuario} onLogout={handleLogout} /> : <Navigate to="/login" />}>
          <Route path="/" element={<Navigate to="/painel" replace />} />
          <Route path="/painel" element={<Home />} />
          <Route path="/clientes" element={<ClientesPage />} />
          <Route path="/oportunidades" element={<Oportunidades />} />
          <Route path="/crm" element={<CRM />} />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/gerador" element={<GeradorArquivos />} />
          {/* Cadastro direto desativado: cliente novo entra pela Oportunidade (Ganho) */}
          <Route path="/clientes/novo" element={<Navigate to="/clientes" />} />
          <Route path="/clientes/:id/editar" element={<><BuscaClientes /><FormCliente /></>} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/sdr" element={<Sdr />} />
          <Route path="/saudadora" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Saudadora /> : <Navigate to="/painel" />} />
          <Route path="/pap" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Pap /> : <Navigate to="/painel" />} />
          <Route path="/closer" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' || (localStorage.getItem('cargoUsuario') || '').toLowerCase().includes('closer') ? <Closer /> : <Navigate to="/painel" />} />
          <Route path="/demandas" element={<Demandas />} />
          <Route path="/sucesso-cliente" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' || (localStorage.getItem('cargoUsuario') || '').toLowerCase().includes('closer') ? <SucessoCliente /> : <Navigate to="/painel" />} />
          <Route path="/financeiro" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Financeiro /> : <Navigate to="/painel" />} />
          <Route path="/capital" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Capital /> : <Navigate to="/painel" />} />
          <Route path="/parceiros" element={<Parceiros />} />
          <Route path="/fornecedores" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Fornecedores /> : <Navigate to="/painel" />} />
          <Route path="/fornecedores/novo" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <FormFornecedor /> : <Navigate to="/painel" />} />
          <Route path="/fornecedores/:id/editar" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <FormFornecedor /> : <Navigate to="/painel" />} />
          <Route path="/configuracoes" element={<Configuracoes />} />
          <Route path="/automacoes" element={<Automacoes />} />
          <Route path="/pesquisa-marca" element={<PesquisaMarca />} />
          <Route path="/inpi" element={<Inpi />} />
          <Route path="/oposicao" element={<Oposicao />} />
          <Route path="/consultar-rpi" element={<ConsultarRpi />} />
          <Route path="/dashboard-revista" element={<DashboardRevista />} />
          <Route path="/assistente" element={<Assistente />} />
          <Route path="/sugestoes" element={<Sugestoes />} />
          <Route path="/apis" element={<Apis />} />
          <Route path="/apis/google-maps" element={<GoogleMaps />} />
          <Route path="/prospeccao" element={<Prospeccao />} />
          <Route path="/anotacoes" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Anotacoes /> : <Navigate to="/painel" />} />
          <Route path="/utilitarios" element={<Utilitarios />} />
          <Route path="/agente-vendas" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <AgenteVendas /> : <Navigate to="/painel" />} />
          <Route path="/comunicacao" element={localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? <Comunicacao /> : <Navigate to="/painel" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
